module.exports = __webpack_public_path__ + "static/media/C1.2c0dbcb7.png";